// components/constants.js
export const ACTIVITIES = {
  break: { label: "Break", color: "#F4B740" },
  focus: { label: "Focus", color: "#0057FF" },
  meeting: { label: "Meeting", color: "#9B51E0" },
  idea: { label: "Idle Time", color: "#FF5C5C" },
};
  